import Vue from 'vue'
import router from './router/index.js'

import requests from "@/api/request";
import apiUrls from '@/api/index.js'
import VueLazyLoad from 'vue-lazyload'
import App from './App.vue'
import Qs from 'qs'
import { HOST } from '@/util/config'

 // 滑动组块
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);


import axios from 'axios'


import Print from 'vue-print-nb'

// 多语言
import VueI18n from 'vue-i18n';
import en from './locales/en';
import zh from './locales/zh';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'zh', // 设置地区
  messages: { // 设置地区信息
    en,
    zh,
  }
});

// 全局引用
Vue.use(Print);





Vue.prototype.$axios = axios;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './plugins/element.js'
// import SlideVerify from 'vue-monoplasty-slide-verify';
// Vue.use(SlideVerify);
import vueEsign from 'vue-esign'
Vue.use(vueEsign)


import AMap from 'vue-amap';
Vue.use(AMap);
// 初始化vue-amap
AMap.initAMapApiLoader({
    // 高德key
    key: '554c6ec96b9d8fd764beabd992666e8b',
    // 插件集合 （插件按需引入）
    plugin: ['AMap.Geolocation', 'AMap.PlaceSearch', 'AMap.ToolBar', 'AMap.Geocoder', 'AMap.Container', 'AMap.Marker']
  });

// 打印机
// import Print from 'vue-print-nb'
// Vue.use(Print);  //注册


Vue.use(VueLazyLoad,{
  loading:'/imgs/loading-svg/loading-bars.svg'
})
Vue.mixin({
  methods: {
    getImageUrl(url) {
      return url.indexOf("http://") != -1 || url.indexOf("https://") != -1 ? url : HOST + url;
    }
  }
})
Vue.prototype.qs = Qs;
Vue.prototype.$api = requests;
Vue.prototype.$apiUrls = apiUrls;
Vue.config.productionTip = false

new Vue({
	i18n,
  router,
  render: h => h(App)
}).$mount('#app')
